import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="font-heading text-xl font-semibold text-foreground-950 whitespace-nowrap">
              Kakobuy<span className="text-primary-500">Polska</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-xs">
              Niezależny przewodnik i platforma odkrywania produktów Kakobuy Spreadsheet. Pomagamy Polakom bezpiecznie kupować z Chin.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-900 text-sm mb-4">Nawigacja</h4>
            <ul className="space-y-2.5">
              <li><a href="#kategorie" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Kategorie</a></li>
              <li><a href="#poradnik" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Poradnik</a></li>
              <li><a href="#bezpieczenstwo" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Bezpieczeństwo</a></li>
              <li><a href="#faq" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">FAQ</a></li>
              <li><Link to="/poradnik-kakobuy" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Artykuły</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-900 text-sm mb-4">Popularne kategorie</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Buty</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Bluzy/Swetry</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">T-Shirty</a></li>
              <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Kurtki</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-900 text-sm mb-4">Kakobuy Spreadsheet</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer">Kakobuy Spreadsheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer">Buy It Now</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Kakobuy Polska Guide. Wszelkie prawa zastrzeżone. Niezależny zasób edukacyjny.
          </p>
          <p className="text-xs text-foreground-400">
            Ta strona NIE jest oficjalną stroną Kakobuy. Jest to niezależny przewodnik.
          </p>
        </div>
      </div>
    </footer>
  );
}